export function updateNotificationsState(state, payload) {
  state[payload.state] = payload.data;
}
